export const FEATURES_BUTTONS = [
    {id: 0, emoji: '🧺', value: 'On-Site Laundry', selected: false},
    {id: 1, emoji: '❄️', value: 'Air Conditioning', selected: false},
    {id: 2, emoji: '🚗', value: 'Parking', selected: false},
    {id: 3, emoji: '💺', value: 'Patio / Balcony', selected: false},
    {id: 4, emoji: '🏊', value: 'Pool', selected: false},
    {id: 5, emoji: '🚲', value: 'Gym', selected: false}
];
